// NX spinner: lucide LoaderCircle turning every 1.2 s; static under reduced motion. Used for actions, never for content loading.
import { LoaderCircleIcon } from "lucide-react";
import type * as React from "react";

import { cn } from "@/lib/cn";

function Spinner({
  className,
  label = "Loading",
  ...props
}: React.ComponentProps<"svg"> & { label?: string }) {
  return (
    <LoaderCircleIcon
      role="status"
      aria-label={label}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
